import {SmartSiteBaseApiV2} from "../SmartSiteBaseApiV2";

export class AutoItemDataApi extends SmartSiteBaseApiV2 {

    public get ControllerName(): any {
        return 'autoItemData';
    }
    
}